var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"el-form",class:[
  _vm.labelPosition ? 'el-form--label-' + _vm.labelPosition : '',
  { 'el-form--inline': _vm.inline }
]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }